import { Component } from '@angular/core';

@Component({
  selector: 'header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrl: './header-mobile.component.scss',
  standalone: false,
})
export class HeaderMobileComponent {}
